
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/citycard-details",
      function () {
        return require("private-next-pages/citycard-details/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/citycard-details"])
      });
    }
  